<div class="modal-dialog">
  <div class="modal-content">

    <div class="modal-header">
        <h4 class="modal-title" id="myCenterModalLabel">{{ 'LABELS.DETAILS' | translate}}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <div class="filterContentContainer">
        <div class="filterContent">
          <ng-container class="ion-no-padding" *ngFor="let divisionItem of divisionWiseData; let i = index;">
            <ion-list class="filters" [lines]="ios ? 'inset' : 'full'">
              <ion-list-header class="filterHeaderLabel">{{divisionItem.TYPE}} - {{divisionItem.SUM | inrdisplay}}
              </ion-list-header>
              <ng-container *ngFor="let itemDetails of divisionItem.details">
                <ion-item class="filterItem">
                  <div class="frp-col50">
                    <label class="frp-label">{{itemDetails.type}} ({{itemDetails.count}})</label>
                  </div>
                  <div class="frp-col50">
                    <strong class="frp-label">{{itemDetails.amt | inrdisplay}}</strong>
                  </div>
                </ion-item>
              </ng-container>
            </ion-list>
          </ng-container>
        </div>
    </div>
    
    <div class="modal-footer">
      <button class="btn  fis-btn" (click)="dismiss()" strong>{{ 'LABELS.CLOSE' | translate}}</button>
    </div>

  </div>

  </div>
</div>
